import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import { fetchBanks } from '../../redux/actions/banks'
import { RootState } from '../../redux/store'
import { emailRegex } from '../../utils/validations'

const AccountsUpdate: React.FC<IAccountsUpdate> = ({
  onClose,
  selectedEditAccount,
  onSubmit,
}) => {
  const banks = useSelector((state: RootState) => state.bank.banks)

  const dispatch = useDispatch()

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const bankType = [
    {
      value: 'Ahorro',
      text: 'Ahorro',
    },
    {
      value: 'Corriente',
      text: 'Corriente',
    },
  ]

  const getDoc = () => docs.find((d) => d.value === selectedEditAccount?.document?.documentType)

  const getBankType = () => bankType.find((v) => v.value === selectedEditAccount?.typeAccount)
  
  const getBankName = () => banks.find(v => v.name === selectedEditAccount.bank)

  const form = useForm({
    defaultValues: {
      ...selectedEditAccount,
      document: {
        ...selectedEditAccount?.document,
        documentType: getDoc()?.value,
      },
      typeAccount: getBankType()?.value,
      bank: getBankName()?.id
    },
  })

  useEffect(() => {
    dispatch(fetchBanks())
  }, [])

  useEffect(() => {
    console.log('selected edit account', selectedEditAccount)
  }, [selectedEditAccount])

  return (
    <Form
      form={form}
      onSubmit={(values) =>
        onSubmit({
          ...values,
          id: selectedEditAccount.id,
          method: selectedEditAccount.type,
        })
      }
      classes="gap-x-6 gap-y-2"
    >
      {selectedEditAccount.type === 'BANK_ACCOUNT' && (
        <>
          <FormItem
            name="bank"
            classes="xl:col-span-6 col-span-12"
            defaultValue={{value: getBankName()?.id, text: getBankName()?.name}}
          >
            <Select
              options={banks.map((bank) => ({
                value: bank.name,
                text: bank.name,
              }))}
              label="Banco"
            />
          </FormItem>

          <FormItem
            defaultValue={getDoc()}
            name="document.documentType"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-2 col-span-4"
          >
            <Select options={docs} label="Tipo" />
          </FormItem>

          <FormItem
            name="document.document"
            classes="xl:col-span-4 col-span-8"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText label="Documento" maxLength={10} />
          </FormItem>

          <FormItem
            name="name"
            classes="xl:col-span-5 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={100} />
          </FormItem>

          <FormItem
            name="accountNumber"
            classes="xl:col-span-4 col-span-12"
            rules={{
              required: 'Es necesaria un número de cuenta',
              minLength: {
                value: 20,
                message: 'El número de cuenta debe poseer 20 dígitos',
              },
              maxLength: {
                value: 20,
                message: 'El número de cuenta debe poseer 20 dígitos',
              },
            }}
          >
            <InputText
              small
              phone={true}
              label="Número de cuenta"
              maxLength={20}
            />
          </FormItem>

          <FormItem
            defaultValue={getBankType()}
            name="bankAccountType"
            classes="xl:col-span-3 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <Select options={bankType} label="Tipo de cuenta" />
          </FormItem>

          <FormItem
            name="email"
            classes="xl:col-span-5 col-span-12"
            rules={{
              pattern: {
                value: emailRegex,
                message: 'El email ingresado debe ser válido',
              },
            }}
          >
            <InputText
              isUpperValue={false}
              small
              label="Correo Electrónico"
              maxLength={255}
            />
          </FormItem>
        </>
      )}

      {selectedEditAccount.type === 'INSTANT_PAYMENT' && (
        <>
          <FormItem
            name="bank"
            classes="xl:col-span-6 col-span-12"
            defaultValue={{value: getBankName()?.id, text: getBankName()?.name}}
          >
            <Select
              options={banks.map((bank) => ({
                value: bank.name,
                text: bank.name,
              }))}
              label="Banco"
            />
          </FormItem>

          <FormItem
            defaultValue={getDoc()}
            name="document.documentType"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-2 col-span-4"
          >
            <Select options={docs} label="Tipo" />
          </FormItem>

          <FormItem
            name="document.document"
            classes="xl:col-span-4 col-span-8"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText label="Documento" maxLength={10} />
          </FormItem>

          <FormItem
            name="name"
            classes="xl:col-span-4 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={100} />
          </FormItem>

          <FormItem
            name="phone"
            classes="xl:col-span-4 col-span-12"
            rules={{
              required: 'Es necesaria un número de cuenta',
              minLength: {
                value: 20,
                message: 'El número de cuenta debe poseer 20 dígitos',
              },
              maxLength: {
                value: 20,
                message: 'El número de cuenta debe poseer 20 dígitos',
              },
            }}
          >
            <InputText small phone={true} label="Teléfono" maxLength={20} />
          </FormItem>
        </>
      )}

      {selectedEditAccount.type === 'OTHER_ACCOUNT' && (
        <>
          <FormItem
            name="name"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={100} />
          </FormItem>

          <FormItem
            name="paymentMethod"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <InputText small label="Método de Pago" maxLength={255} />
          </FormItem>

          <FormItem
            name="description"
            classes="col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <TextArea
              label="Descripción"
              placeholder="Ingresar datos de la cuenta"
              maxLength={255}
            />
          </FormItem>

        </>
      )}

      <div className="col-span-12 h-full flex flex-row mt-5">
        <div className="w-1/2 mr-5 pl-1">
          <Button
            onClick={() => {
              onClose()
              console.log('cancel')
            }}
            type="outline"
            classes="w-full"
          >
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button type="primary" classes="w-full" htmlType="submit">
            Editar
          </Button>
        </div>
      </div>
    </Form>
  )
}

interface IAccountsUpdate {
  onClose: () => void
  selectedEditAccount: any
  onSubmit: (values: any) => void
}

export default AccountsUpdate
